export const STORAGE_KEYS = {
    UI_THEME_MODE: 'crmseller-ui-theme-mode',
    APP_VERSION: 'APP_VERSION',
    STATE: 'state',
} as const
